module.exports = __webpack_public_path__ + "img/gouwuche1.77b5dd81.png";